export const OutLinks = {
	pixel_workle: 'https://www.workle.ru/request/:partnerId/questionnaire/filled/:partnerRequestId',
	pixel_rko: {
		path: 'https://bankiru.go2cloud.org/SLgH?adv_sub=:id',
		partner_id: 'bdf95d3aafdae81607dd',
		path_leads:
			'http://api.leads.su/advertiser/conversion/createUpdate' +
			'?token=70efcc0f048e2c80dea43bc88ba74e6c&goal_id=0&status=pending' +
			'&transaction_id=:transactionId&adv_sub=:partnerRequestId',
	},
	getIp: 'https://api.ipify.org',
	daData: 'https://suggestions.dadata.ru/suggestions/api/4_1/rs/iplocate/address?ip=:ip',
	sberIsClient:
		'https://sbi.sberbank.ru:9443/ic/ufs/index.html#/credits/credit-financing/products?partnerCode=dasredaclient',
	sberNoClient: `https://sbi.sberbank.ru:9443/ic/dcb/login.html#/register?ReturnTo=/guest-area/org-register
		&BackUrl=https%3A%2F%2Fsbi.sberbank.ru%3A9443%2Fic%2Fdcb%2Findex.html%23%2Fguest-area
		&partnerCode=dasredaneclonlinemain&productCode=CreditMMB`,
	sberIsClientLandingBussines:
		'https://sbi.sberbank.ru:9443/ic/ufs/index.html#/credits/credit-financing/' +
		'create?category=cbc&partnerCode=dasredacbc',
	sberNoClientLandingBussines: `https://sbi.sberbank.ru:9443/ic/dcb/login.html#/register
		?ReturnTo=/guest-area/org-register
		&BackUrl=https%3A%2F%2Fsbi.sberbank.ru%3A9443%2Fic%2Fdcb%2Findex.html%23%2Fguest-area
		&partnerCode=dasredaneclcbc&productCode=CreditMMB`,
	postback: {
		'7703387266': `https://cpaex.scaletrk.com/track/goal-by-click-id?goal_id=3627
		&click_id=:click_id&track_id=:track_id`,
	},
	privacyPolicyHref:
		'https://cdn.dasreda.ru/storage-data/7577f37a-d9d6-412d-8358-0fd7423929b6/politika_obrabotki_pdn_30062023.pdf',
	cookie_policy:
		'https://cdn.dasreda.ru/storage-data/850d2322-fe52-45f7-b3ba-8e08f9a9bde0/politika_ispol-zovaniya_cookies.pdf',
	selfEmployedInnPolicyHref:
		'https://cdn.dasreda.ru/storage-data/dd5c5735-2d0b-4333-82b7-275cd67b6989/' +
		'soglasie_na_obrabotku_pdn_-uznaj_svoj_inn.pdf',
}
